import { Text, Heading, Box } from "@chakra-ui/react";
import { PopulatedWallet } from "@syla/shared/types/models/WalletBase";
import React from "react";
import { parseSyncErrorMessage } from "../../../../api/errors/parsers/parseSyncErrorMessage";

/**
 * Display a permanent error message for a wallet with a sync-related error.
 */
export function WalletSyncErrorBox({
  wallet,
}: {
  wallet: PopulatedWallet;
}): React.ReactElement | null {
  if (!wallet.syncError) {
    return null;
  }

  const error = parseSyncErrorMessage(
    wallet.dataSource.syncAuthType,
    wallet.syncError,
    wallet.dataSource.type,
  );

  return (
    <Box
      w="full"
      px={4}
      py={2}
      backgroundColor="warning.100"
      borderWidth="1px"
      borderColor="warning.300"
      borderRadius="md"
    >
      <Heading textAlign="left" size="xs" mb="10px">
        {error.title}
      </Heading>
      <Text textAlign="left">{error.message}</Text>
    </Box>
  );
}
